import React from 'react';
import StopwatchApp from './components/StopwatchApp';
import { AppProvider } from './contexts';

const App: React.FC = () => {
  return (
    <div className="app">
      <AppProvider>
        <StopwatchApp />
      </AppProvider>
    </div>
  );
};

export default App;
